import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '@/store';

export const selectFluxosArbitrais = (state: RootState) => state.fluxosArbitrais;

const ACTION_STATE_OCIOSO: { duplicando: boolean; publicando: boolean; arquivando: boolean } = {
  duplicando: false,
  publicando: false,
  arquivando: false,
};

export const selectFluxoArbitralActionState =
  (fluxoId: string) =>
  (state: RootState): { duplicando: boolean; publicando: boolean; arquivando: boolean } =>
    state.fluxosArbitrais.actionLoading[fluxoId] ?? ACTION_STATE_OCIOSO;

export const selectLexisAtivasStatus = (state: RootState) =>
  state.fluxosArbitrais.lexisAtivasStatus;

/** Lexis ativas de um gatilho: as opções do seletor "qual Lexi" do nó que dispara `eventType`. */
export const selectLexisAtivasPorGatilho = createSelector(
  [
    (state: RootState) => state.fluxosArbitrais.lexisAtivas,
    (_state: RootState, eventType: string) => eventType,
  ],
  (lexis, eventType) => lexis.filter((lexi) => lexi.eventType === eventType),
);
export const selectFluxosArbitraisCreating = (state: RootState) => state.fluxosArbitrais.creating;

export const selectFluxosArbitraisLastError = (state: RootState) => state.fluxosArbitrais.lastError;
